import React from "react";
import OrdersPage from "Common/Components/OrdersPage";

// سفارش‌های تحویل شده به مشتری = سفارش‌هایی که order_status آن‌ها delivered است.
// این وضعیت با دکمه‌ی «تحویل به مشتری» در صفحه‌ی «سفارش‌های بارگیری شده» ایجاد می‌شود؛ این‌جا
// آخرین مرحله‌ی گردش‌کار است، پس دکمه‌ی پیشروی ندارد، فقط دکمه‌ی بازگشت (به loaded).
const Index = () => (
  <OrdersPage
    pageTitle="سفارش‌های تحویل شده به مشتری"
    orderStatus="delivered"
    canRevert
    emptyText="هیچ سفارشی تحویل داده نشده است"
  />
);

export default Index;
